import type { ReactNode } from "react"

export const SettingsSectionTitle = ({ title, subtitle }: { title: string; subtitle?: string | ReactNode }) => {
  return (
    <div className="mb-6 text-xl text-t100">
      <div className="mb-2 text-xl text-t100">{title}</div>
      {subtitle ? <div className="mb-4 text-sm text-t200">{subtitle}</div> : null}
    </div>
  )
}
